// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  font-size: 14px;
  border-radius: 0 0 6px 6px;
  background: var(--White-6F, #FFF);
  height: 56px;
  position: relative;
  z-index: 10;
}

.totals-pag {
  color: var(--N2-Grey-696969, #696969);
  font-family: "Segoe UI";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
}

.custom-pagination {
  display: flex;
  align-items: center;
  gap: 16px;
}

.pagination-btn-sel {
  padding: 4px 12px;
  border: nonel;
  background: white;
  color: rgba(0, 0, 0, 0.65);
  cursor: pointer;
  border-radius: 2px;
  transition: all 0.3s;
  color: var(--Purple, #5F09E0);
  text-align: right;
  font-family: "Segoe UI";
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  /* 142.857% */
}

.pagination-btn-sel:hover {
  color: var(--DX-P3, #AF84EF);
}

.pagination-btn-disable {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  cursor: not-allowed;
}

.pagination-btn-disable:hover {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
}

.page-size-selector-sel {
  display: flex;
  align-items: center;
  position: relative;
  z-index: 100;
}

.page-size-select {
  padding: 4px 8px;
  background: white;
  color: var(--N2-Grey-696969, #696969);
  text-align: right;
  font-family: "Segoe UI";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid var(--N4-Grey, #E5E5E5);
  outline: none;
}

.page-size-select:focus {
  outline: none;
  border-color: var(--N4-Grey, #E5E5E5);
}

.page-size-selector-sel select {
  outline: none !important;
}

.page-size-selector-sel .ant-select-single .ant-select-selector {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

.page-size-selector-sel .ant-select-focused:not(.ant-select-disabled):not(.ant-select-customize-input) .ant-select-selector {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

.page-size-selector-sel .ant-select-outlined:not(.ant-select-customize-input) .ant-select-selector {
border:none !important;
}

.page-size-selector-sel .ant-select-single .ant-select-selector:focus {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

.page-size-selector-sel .ant-select-single .ant-select-selector:active {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

.page-size-selector-sel .ant-select-arrow {
  color: var(--N2-Grey-696969, #696969) !important;
}

.page-size-selector-sel select option {
  background-color: var(--White-6F, #FFF) !important;
  color: var(--N2-Grey-696969, #696969) !important;
}

.page-size-selector-sel select option:checked {
  background-color: var(--White-6F, #FFF) !important;
  color: var(--N2-Grey-696969, #696969) !important;
}
.page-jumper {
color: var(--Neutral-I, #707070);
text-align: center;

/* Body */
font-family: "Segoe UI";
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 140%; /* 19.6px */
}

.page-input {
  width: 56px;
  padding: 4px 8px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 14px;
  color: var(--Blk_000000, #000);
text-align: right;
font-family: "Segoe UI";
font-weight: 600;
}

.page-input:focus {
  outline: none;
  border-color: #5F09E0;
}
`, "",{"version":3,"sources":["webpack://./src/components/pagination/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,0BAA0B;EAC1B,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,6BAA6B;EAC7B,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;EACrC,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;AACA,sBAAsB;AACtB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,kDAAkD;EAClD,gDAAgD;AAClD;;AAEA;EACE,kDAAkD;EAClD,gDAAgD;AAClD;AACA;AACA,gCAAgC;AAChC,kBAAkB;;AAElB,SAAS;AACT,uBAAuB;AACvB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB,EAAE,WAAW;AAC9B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,8BAA8B;AAChC,iBAAiB;AACjB,uBAAuB;AACvB,gBAAgB;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB","sourcesContent":[".pagination-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px;\n  font-size: 14px;\n  border-radius: 0 0 6px 6px;\n  background: var(--White-6F, #FFF);\n  height: 56px;\n  position: relative;\n  z-index: 10;\n}\n\n.totals-pag {\n  color: var(--N2-Grey-696969, #696969);\n  font-family: \"Segoe UI\";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 140%;\n}\n\n.custom-pagination {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.pagination-btn-sel {\n  padding: 4px 12px;\n  border: nonel;\n  background: white;\n  color: rgba(0, 0, 0, 0.65);\n  cursor: pointer;\n  border-radius: 2px;\n  transition: all 0.3s;\n  color: var(--Purple, #5F09E0);\n  text-align: right;\n  font-family: \"Segoe UI\";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 20px;\n  /* 142.857% */\n}\n\n.pagination-btn-sel:hover {\n  color: var(--DX-P3, #AF84EF);\n}\n\n.pagination-btn-disable {\n  color: rgba(0, 0, 0, 0.25);\n  border-color: #d9d9d9;\n  cursor: not-allowed;\n}\n\n.pagination-btn-disable:hover {\n  color: rgba(0, 0, 0, 0.25);\n  border-color: #d9d9d9;\n}\n\n.page-size-selector-sel {\n  display: flex;\n  align-items: center;\n  position: relative;\n  z-index: 100;\n}\n\n.page-size-select {\n  padding: 4px 8px;\n  background: white;\n  color: var(--N2-Grey-696969, #696969);\n  text-align: right;\n  font-family: \"Segoe UI\";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 140%;\n  cursor: pointer;\n  border-radius: 4px;\n  border: 1px solid var(--N4-Grey, #E5E5E5);\n  outline: none;\n}\n\n.page-size-select:focus {\n  outline: none;\n  border-color: var(--N4-Grey, #E5E5E5);\n}\n\n.page-size-selector-sel select {\n  outline: none !important;\n}\n\n.page-size-selector-sel .ant-select-single .ant-select-selector {\n  border: none !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.page-size-selector-sel .ant-select-focused:not(.ant-select-disabled):not(.ant-select-customize-input) .ant-select-selector {\n  border: none !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.page-size-selector-sel .ant-select-outlined:not(.ant-select-customize-input) .ant-select-selector {\nborder:none !important;\n}\n\n.page-size-selector-sel .ant-select-single .ant-select-selector:focus {\n  border: none !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.page-size-selector-sel .ant-select-single .ant-select-selector:active {\n  border: none !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.page-size-selector-sel .ant-select-arrow {\n  color: var(--N2-Grey-696969, #696969) !important;\n}\n\n.page-size-selector-sel select option {\n  background-color: var(--White-6F, #FFF) !important;\n  color: var(--N2-Grey-696969, #696969) !important;\n}\n\n.page-size-selector-sel select option:checked {\n  background-color: var(--White-6F, #FFF) !important;\n  color: var(--N2-Grey-696969, #696969) !important;\n}\n.page-jumper {\ncolor: var(--Neutral-I, #707070);\ntext-align: center;\n\n/* Body */\nfont-family: \"Segoe UI\";\nfont-size: 14px;\nfont-style: normal;\nfont-weight: 400;\nline-height: 140%; /* 19.6px */\n}\n\n.page-input {\n  width: 56px;\n  padding: 4px 8px;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  font-size: 14px;\n  color: var(--Blk_000000, #000);\ntext-align: right;\nfont-family: \"Segoe UI\";\nfont-weight: 600;\n}\n\n.page-input:focus {\n  outline: none;\n  border-color: #5F09E0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
